<template lang="pug">
.inside-padding
  form(@submit.prevent="openConfirmation")
    h3.capitalize Acuse de recibo de factura

    .input-container
      input.input(v-model="cufe" required :disabled="isSending")
      label.label(:class="{ show: cufe }") CUFE de la factura

    p.dian-receipt-help
      | Registra ante la DIAN que N89 SAS recibió electrónicamente esta factura.

    button.dian-receipt-button(
      type="submit"
      :disabled="isSending || !cufe.trim()"
    )
      span(:class="{ disable: isSending }") {{ isSending ? 'Enviando a DIAN...' : 'Enviar acuse de recibo' }}
      .bar-action(:class="{ active: isSending }")

    .dian-receipt-result(v-if="resultMessage" :class="resultClass")
      | {{ resultMessage }}
      .dian-receipt-detail(v-if="resultDetail") {{ resultDetail }}

  .container-dian-receipt-confirmation.center(v-if="showConfirmation")
    .container-message
      h3 Confirmación
      .text
        p ¿Confirmas que N89 SAS recibió esta factura electrónica?
        p Esta acción generará el evento RADIAN 030 ante la DIAN.
      .buttons
        button.dian-receipt-modal-button(type="button" @click="showConfirmation = false") Cancelar
        button.dian-receipt-modal-button.confirm(type="button" @click="confirmSend") Confirmar acuse
</template>

<script>
import gql from '@my/graphql'
import gqlInvoice from '@/graphql/invoice'

export default {
  name: 'DianReceipt',

  data () {
    return {
      cufe: '',
      isSending: false,
      showConfirmation: false,
      resultMessage: '',
      resultDetail: '',
      resultClass: ''
    }
  },

  methods: {
    openConfirmation () {
      if (this.isSending || !this.cufe.trim()) return
      this.showConfirmation = true
    },

    async confirmSend () {
      this.showConfirmation = false
      this.resultMessage = ''
      this.resultDetail = ''
      this.resultClass = ''
      this.isSending = true

      const response = await gql.mutate(
        gqlInvoice.SEND_RECEIPT_ACKNOWLEDGEMENT,
        { cufe: this.cufe.trim() },
        false
      )

      this.isSending = false

      const result = response &&
        response.data &&
        response.data.sendInvoiceReceiptAcknowledgement

      if (!result) {
        this.resultClass = 'error'
        this.resultMessage = '✕ No fue posible registrar el acuse de recibo'
        this.resultDetail = (response && response.error) || 'No hubo respuesta del servidor'
        return
      }

      if (result.success && result.alreadyExists) {
        this.resultClass = 'success'
        this.resultMessage = '✓ Esta factura ya tenía registrado el acuse de recibo'
        return
      }

      if (result.success) {
        this.resultClass = 'success'
        this.resultMessage = '✓ Acuse de recibo registrado ante la DIAN'
        return
      }

      this.resultClass = 'error'
      this.resultMessage = '✕ No fue posible registrar el acuse de recibo'
      this.resultDetail = result.message
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

.inside-padding
  padding-bottom 2em

.dian-receipt-help
  margin 0 1em 1.5em 1em
  font-size 1rem
  color rgb(80, 80, 80)
  text-align left

.dian-receipt-button
  display inline-flex
  justify-content center
  align-items center
  padding 1.3em 2em
  borderRadius(.3rem)
  cursor pointer
  noSelect()
  background-color var(--color-principal)
  border none
  color white
  font-size 1rem
  text-transform uppercase
  position relative
  overflow hidden
  margin-left 1em

.dian-receipt-button:disabled
  opacity .6
  cursor default

.dian-receipt-button .disable
  color rgba(255, 255, 255, .85)

.dian-receipt-result
  margin 1.5em 1em 0 1em
  font-size 1.1em
  text-align left

.dian-receipt-result.success
  color #1b7f3a

.dian-receipt-result.error
  color #b42318

.dian-receipt-detail
  margin-top .5em
  font-size .95em
  color rgb(80, 80, 80)

.container-dian-receipt-confirmation
  position fixed
  width 100%
  height 100%
  left 0
  top 0
  background-color rgba(0, 0, 0, .4)
  z-index 12000
  display flex
  justify-content center
  align-items center

.container-dian-receipt-confirmation .container-message
  background-color var(--background-principal)
  padding 2em 3em
  borderRadius(.5em)
  width 100%
  max-width 40em

.container-dian-receipt-confirmation .text
  margin .5em 0 1em 0
  font-size 1.1em

.container-dian-receipt-confirmation .text p
  margin .5em 0

.container-dian-receipt-confirmation .buttons
  display flex
  justify-content center
  align-items center
  gap 1em

.dian-receipt-modal-button
  display inline-flex
  justify-content center
  align-items center
  padding 1em 1.6em
  borderRadius(.3rem)
  cursor pointer
  noSelect()
  background transparent
  border 1px solid rgba(0, 0, 0, .3)
  font-size 1rem
  text-transform uppercase

.dian-receipt-modal-button.confirm
  background-color var(--color-principal)
  border none
  color white
</style>



// WEBPACK FOOTER //
// src/components/pages/invoice/DianReceipt.vue